import ExternalRegistration from '../pages/auth/ExternalRegistration'
import Login from '../pages/auth/Login'
import ForgotPassword from '../pages/auth/ForgotPassword'
import ResetPassword from '../pages/auth/ResetPassword'
import UserRegistration from '../pages/auth/UserRegistration'
import UserSetup from '../pages/setup/UserSetup'
import UserSuccess from '../pages/setup/UserSuccess'

import Dashboard from '../pages/merchant/Dashboard'
import Archive from '../pages/merchant/Archive'
import Payments from '../pages/merchant/Payments'
import Bookings from '../pages/merchant/Bookings'
import WaitingList from '../pages/merchant/WaitingList'
import PaymentInformation from '../pages/merchant/PaymentInformation'
import NotFoundError from '../pages/errors/NotFoundError'
import ProfileSettings from '../pages/profile/ProfileSettings'
import Checkout from '../pages/payment/Checkout'
import CheckoutOverdueFee from "../pages/payment/CheckoutOverdueFee"
import CheckoutStartupFee from "../pages/payment/CheckoutStartupFee";
import Success from '../pages/payment/Success'
import Failed from '../pages/payment/Failed'
import PayOverdue from "../pages/payment/PayOverdue";
import MobilePaySuccess from '../pages/payment/mobilepay/Success'

// Vipps
import Process from "../pages/payment/vipps/Process"
import VippsSuccess from "../pages/payment/vipps/Success"
import VippsFailed from "../pages/payment/vipps/Failed"

// Kamstrup
import WaterUsageStats from "../pages/kamstrup/WaterUsageStats"
import AlarmSettings from "../pages/kamstrup/AlarmSettings"

export default () => [
	{ path: '/', name: 'root', redirect: { name: 'dashboard' } },
	{ path: '/login', name: 'login', component: Login, meta: {auth: false} },
	{ path: '/registration', name: 'registration', component: ExternalRegistration, meta: {auth: false} },
	{ path: '/forgot', name: 'forgot', component: ForgotPassword, meta: { auth: false } },
	{ path: '/password/reset/:token', name: 'resetpassword', component: ResetPassword },
	{ path: '/register/:token', name: 'userregistration', component: UserRegistration },

	{ path: '/setup/:process', name: 'usersetup', component: UserSetup, meta: { auth: true } },
	{ path: '/setupcomplete', name: 'setupsuccess', component: UserSuccess, meta: { auth: true } },

	{ path: '/dashboard', name: 'dashboard', component: Dashboard, meta: {auth: true} },
	{ path: '/archive', name: 'archive', component: Archive, meta: {auth: true} },
	{ path: '/dashboard/:subscriptionId', name: 'subscriptiondashboard', component: Dashboard, meta: {auth: true} },
	{ path: '/payments', name: 'payments', component: Payments, meta: {auth: true} },
	{ path: '/bookings', name: 'bookings', component: Bookings, meta: {auth: true} },
	{ path: '/waitinglist', name: 'wait_list', component: WaitingList, meta: {auth: true} },
	{ path: '/paymentinformation', name: 'paymentinformation', component: PaymentInformation, meta: {auth: true} },
	{ path: '/profile', name: 'profile', component: ProfileSettings, meta: {auth: true} },

	{ path: '/checkout/:containerId', name: 'checkout', component: Checkout, meta: {auth: true} },
	{ path: '/success', name: 'success', component: Success, meta: {auth: true} },
	{ path: '/failed', name: 'failed', component: Failed, meta: {auth: true} },

  { path: '/checkout/overdue', name: 'checkout_overdue_fee', component: CheckoutOverdueFee, meta: {auth: true} },
  { path: '/checkout/startup', name: 'checkout_startup_fee', component: CheckoutStartupFee, meta: {auth: true} },

  { path: '/overdue/pay', name: 'payoverdue', component: PayOverdue, meta: {auth: true} },

  { path: '/mobile-pay/success', name: 'mobile_pay_success', component: MobilePaySuccess, meta: {auth: true} },

  { path: '/vipps/process', name: 'vipps_process', component: Process, meta: {auth: true} },
  { path: '/vipps/success', name: 'vipps_success', component: VippsSuccess, meta: {auth: true} },
  { path: '/vipps/failed', name: 'vipps_failed', component: VippsFailed, meta: {auth: true} },

  { path: '/water/usage', name: 'kamstrup', component: WaterUsageStats, meta: {auth: true} },
  { path: '/water/alarm-settings', name: 'kamstrup_alarm_settings', component: AlarmSettings, meta: {auth: true} },

	{ path: '/404', name: '404', component: NotFoundError },

	{ path: '*', redirect: {name: '404'} }
]



// WEBPACK FOOTER //
// ./src/router/routes.js